// extracted by mini-css-extract-plugin
export var orderSummary = "_np-0";
export var showMoreLessButton = "_np-1";